interface IRenderLink {
  value: any;
}
const RenderLink = ({ value }: IRenderLink) => {
  return <i className="textLink pointer">{value}</i>
}

export default RenderLink;
